// extracted by mini-css-extract-plugin
export default {"uncheckedBox":"checkbox_uncheckedBox__3966e","checkboxSquare":"checkbox_checkboxSquare__XeP66","checkedBox":"checkbox_checkedBox__HoHQt","check":"checkbox_check__Wvddg"};